import { Box, Stack, Typography } from "@mui/material"
import React from "react"
import BasicLogo from "src/components/common/BasicLogo"
import { useIsMobile } from "src/hooks/useIsMobile"

const ClubPopup = () => {
  const isMobile = useIsMobile()
  return (
    <Box sx={{ width: isMobile ? "100%" : "500px", bgColor: "red" }}>
      <Stack sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <BasicLogo />
      </Stack>
      <Stack spacing={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 1 }}>
        <Typography textAlign='center' color='primary' variant='h4' fontWeight='bold'>
          متقاضیان محترم سامانه جت وام
        </Typography>
        <Typography variant='subtitle2' fontSize={13} textAlign='justify'>
          این سامانه با هدف مشتری مداری و به پاس حمایت همیشگی شما، همزمان با ارائه خدمات تسهیلات، امکان استفاده از بسته
          های تخفیفی شرکای تجاری و شرکت در قرعه کشی را فراهم نموده است.
        </Typography>
        <Typography variant='subtitle2' fontSize={13} textAlign='justify'>
          بنابراین شما می توانید علاوه بر انتخاب بسته های تسهیلاتی از بسته های تخفیفی و شرکت در قرعه کشی نیز استفاده
          نمایید.
        </Typography>
      </Stack>
    </Box>
  )
}

export default ClubPopup
